<template>
  <div class="page">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div style="min-height:100vh" class="top-spacing container">
      <div class="full-width">
        <span
          style="color: black;"
          class="c-caption c-black  fw-45 mt-20 mb-10"
        >
          {{ $t("wap.text64") }}
        </span>
        <div
          style="min-height: 70px;background:#406ee2; padding:10px 10px 0 10px"
          class="container-surplus border-radius-12 flex mt-20 justify-content-space-between"
        >
          <div>
            <span class="c-white-text c-caption">{{ $t("wap.text65") }}</span>
            <h3
              style="margin: 0; padding:0"
              class="total-money c-white-text fw-600"
            >
              {{ formatNumber($store.getters.point) }}
            </h3>
          </div>
          <div>
            <img :src="icons.IconPointWallet" alt="" />
          </div>
        </div>
        <div class="box-recharge mt-20">
          <div class="ml-10 mr-10 mb-10">
            <div>
              <img class="mr-10" :src="icons.IconMoney" alt="" />
              <span class="c-caption c-black lf-18">{{
                $t("wap.text66")
              }}</span>
            </div>
            <div
              style="min-height: 65px; position: relative !important;"
              class="input-recharge ml-5"
            >
              <!-- <h2 class="fw-450" style="margin:10px 0;">
                      {{ formatNumber(money) }}
                    </h2> -->
              <input
                class="input-money"
                type="tel"
                pattern="\d*"
                placeholder="0"
                v-model="moneyModel"
                @input="onInputPrice"
              />
            </div>
            <div class="option-recharge">
              <el-button
                class="btn-option-recharge"
                @click="handleAddMoney(item)"
                v-for="item in list_value_suggest"
                :key="item"
              >
                {{ formatNumber(item) }}</el-button
              >
            </div>
          </div>

          <div
            style="border-top: 1px solid #cac7c7; "
            class="flex align-items-"
          >
            <div class=" mr-10 ml-10 mt-10">
              <p class="c-tiny " style="color: #999999">
                {{ $t("wap.text67") }}:
                <span class="fw-700 c-bold-text">150.000 đ</span>
              </p>
            </div>
          </div>
        </div>
        <div class="mt-20 container-btn-submit">
          <el-button
            @click="handleCreateRequestPoint"
            :loading="isLoadingSubmit"
            class="btn-booking bg-btn-main w-100 c-white-text border-radius-8 "
            >{{ $t("wap.text68") }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconPointWallet from "@/assets/img/iconV2/icon-point-wallet.svg";
import IconMoney from "@/assets/img/iconV2/icon-money-gold.svg";
import { formatNumber, formatPrice } from "@/utils/formatData";
import { setDepositAmount } from "@/utils/booked";
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";

export default {
  name: "PointWallet",
  components: {
    MainNavBarWapV2
  },
  data() {
    return {
      is_lock: false,
      moneyModel: formatPrice(""),
      isLoadingSubmit: false,
      money: "",
      isMobile: false,
      infoHeader: {
        title: this.$t("rechargePoints"),
        isShowHomeIcon: false
      },
      list_value_suggest: [150000, 1500000, 15000000, 150000000],
      icons: {
        IconPointWallet,
        IconMoney
      }
    };
  },
  computed: {
    resizeClass() {
      return {
        mobile: this.isMobile,
        desktop: !this.isMobile
      };
    }
  },
  watch: {},
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    suggestion(money = 0) {
      if (this.is_lock) return this.list_value_suggest;
      let list_value = [];
      let _heso = 1;
      while (list_value.length < 4) {
        let money_suggest = this.getMoneySugest(money, _heso);
        console.log("money_suggest___", money_suggest);
        let { cost, heso } = money_suggest;
        list_value.push(cost);
        _heso = heso * 10;
      }
      list_value = list_value.filter(d => d > 0);
      console.log(list_value);
      this.list_value_suggest = [...list_value];
      return list_value;
    },

    getMoneySugest(money, heso = 1) {
      let cost = money * heso;
      if (cost < 50000) {
        let _heso = heso * 10;
        return this.getMoneySugest(money, _heso);
      } else if (cost >= 50000 && cost <= 2000000000) {
        return { cost, heso };
      } else {
        return { cost: 0, heso };
      }
    },
    formatPrice,
    onInputPrice(val) {
      const moneyDefault = 150000;
      // console.log("val______________", val.target.value);
      const value = val.target.value;
      // console.log("money____________", value);
      this.money = value.toString().replaceAll(".", "");
      this.suggestion(this.money || moneyDefault);

      this.moneyModel = this.formatPrice(value);
    },
    async handleCreateRequestPoint() {
      if (!this.money) {
        this.$message.error(this.$t("wap.text125"));
        return;
      }
      if (this.money < 150000) {
        this.$message.error(`${this.$t("wap.text123")} 150.000đ.`);
        return;
      }
      setDepositAmount(this.money);
      this.$router.push({
        name: "wap-wallet-payment-method",
        params: { payment_amount: this.money }
      });
    },
    handleAddMoney(val) {
      this.money = val;
      this.moneyModel = this.formatPrice(val);
    },
    formatNumber,
    handleResize() {
      if (window.innerWidth < 768) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
      console.log("is mobile", this.isMobile);
    }
  }
};
</script>

<style scoped>
.top-spacing {
  padding-top: 100px;
}
.input-money {
  position: absolute;
  top: 0;
  opacity: 1 !important;
  margin-top: 10px !important;
  color: #000000;
  font-weight: 450 !important;
  font-size: 30px !important;
}
/* .page {
      padding: 0px 20px;
      background-color: #f0f1f5;
    } */
.option-recharge {
  padding-left: -10px;
  margin-left: -10px;
}
.btn-option-recharge {
  padding: 10px;
  margin-left: 10px;
  margin-bottom: 10px;
  border-radius: 100px;
  font-size: 12px;
  border: 1px solid #cac7c7;
}
.box-recharge {
  background: #ffff;
  box-shadow: 0px 2px 4px 0px #00000033;
  border-radius: 10px;
  padding: 10px 0;
}
.page {
  background-color: #f0f1f5;
}
hr {
  border: none;
  border-top: 1.5px dotted #e2e2e2;
  color: #fff;
  margin: 8px 0px;
  background-color: #fff;
  height: 4px;
  width: 100%;
}
.div-info-insurance {
  background-color: white;
  border: 1px solid #e2e2e2;
  border-radius: 18px;
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 20px;
}
.icon-list {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.info-icon {
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 2px 0px;
}
p {
  margin: 2px 0px;
  font-size: medium;
  font-weight: 500;
}
.icon-list-info {
  display: flex;
  justify-content: left;
  align-items: center;
}
.btn-insurance-container {
  min-height: 24px;
  border: 1px solid #406ee2;
  border-radius: 100px;
}
.mobile {
  display: block;
}
.desktop {
  display: none;
}
.typeButton {
  width: 160px;
  display: block;
  border-radius: 20px !important;
}
.switchButton {
  width: 50%;
}
::v-deep .switchButton.el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0 20px 20px 0;
  width: 100%;
}

::v-deep .switchButton.el-radio-button:first-child .el-radio-button__inner {
  border-radius: 20px 0 0 20px;
  width: 100%;
}
::v-deep :focus {
  box-shadow: none !important;
}
.popper-text {
  font-size: small !important;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .top-spacing {
    padding-top: 75px;
  }
}
</style>

<style>
.el-loading-98234 {
  margin-top: 30px !important;
  position: relative !important;
  background-color: #f0f1f5 !important;
}
.popper-class {
  width: 90% !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  color: black !important;
}
</style>
